import React from 'react';
import {classes, style} from './doppe-viewer-scroll-view.st.css';
import {reactCreateMemo, ScrollView} from "@wix/devzai-utils-react";
import type {Values} from "@wix/devzai-utils-common";

export const DoppeViewerScrollViewSize = {
    Medium: 'medium',
    Small: 'small'
} as const;

export type DoppeViewerScrollViewSize = Values<typeof DoppeViewerScrollViewSize>;

export const DoppeViewerScrollView = reactCreateMemo(function DoppeViewerScrollView (props: DoppeViewerScrollView.Props) {
    const {
        size = DoppeViewerScrollViewSize.Medium,
        scrollViewRef,

        className,
        ...restProps
    } = props;

    return (
        <ScrollView
            {...restProps}
            className={style(classes.root, {size: size}, className)}
            ref={scrollViewRef}
        />
    );
});

export namespace DoppeViewerScrollView {

    export interface Props extends ScrollView.Props {
        size?: DoppeViewerScrollViewSize;
        scrollViewRef?: React.Ref<ScrollView>
    }
}
